import { Component } from 'react';
import { connect } from 'react-redux';
import TableWithoutPagination from "../../Table/TableWithoutPagination"
import InterventionReportField from '../InterventionReportField'
import Icon from "@mui/material/Icon/Icon";
import Button from "@mui/material/Button/Button";
import { guid } from '../../../utils'
import { generateDefaultField } from '../../../redux/intervention/interventionActions'
import { getStateAccessor } from '../../../lib/evaluateStringAsCodeHelper'
import { getFieldVisibility, getFieldMandatory } from '../../../redux/intervention/interventionActions';
import { getCurrentFunctionName } from '../../../performanceModeManager';
import "./InterventionArrayField.css";

function getDefaultRow(fieldsTypes, blocId, stateAccessor) {
    let value = generateDefaultField(fieldsTypes[0], blocId, stateAccessor);
    value.mobile_id = guid();

    value.id = 0;
    return value;
}

class InterventionArrayField extends Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: props.value.value_field_ids.filter((r) => !r.deleted),
            columns: [
                {
                    Header: "",
                    id: 'actions',
                    width: 50,
                    className: "fiftyMaxWidth",
                    Cell: this.renderButtons.bind(this)
                },
                {
                    Header: () => <div style={{ textAlign: "center" }}>{this.props.model.name}</div>,
                    id: this.props.model.code,
                    width: 100,
                    className: "hundredMaxWidth",
                    filterable: false,
                    Cell: row => {
                        if (!row.row.original || row.row.original.id === 0 || row.row.original.deleted)
                            return null;


                        let stateAccessor = getStateAccessor(this.props);
                        let visible = getFieldVisibility(this.props.blocs, this.props.blocTypes,
                            this.props.blocId, this.props.model.field_type_ids[0], stateAccessor);
                        let required = getFieldMandatory(this.props.blocs, this.props.blocTypes,
                            this.props.blocId, this.props.model.field_type_ids[0], stateAccessor);

                        return (
                            <InterventionReportField fieldValueChange={this.childrenValueChange(row.row.index)}
                                id={row.row.original.mobile_id} model={this.props.model.field_type_ids[0]} visible={visible}
                                value={row.row.original} blocId={this.props.blocId} blocType={this.props.blocType} required={required} />
                        );
                    }
                },
            ]
        }
    }

    static getDerivedStateFromProps(props, state) {
        let rows = props.value.value_field_ids.filter((r) => !r.deleted);
        state.rows = [...rows];
        return state;
    }

    childrenValueChange = (index) => (fieldTypeId, childrenFieldValue) => {
        const rows = this.props.value.value_field_ids.filter(r => !r.deleted && r.id !== 0);
        let row = rows[index];

        if (!row) {
            console.error("Il semble qu'un enfant ait été modifié mais impossible de retrouver lequel");
            return;
        }

        childrenFieldValue.id = row.id;

        rows.splice(index, 1, childrenFieldValue)

        let fieldValue = this.props.value;
        fieldValue.value_field_ids = rows

        this.props.fieldValueChange(fieldValue);
    }

    addRow() {
        const rows = this.props.value.value_field_ids.filter(r => !r.deleted && r.id !== 0);
        let newRow = getDefaultRow(this.props.model.field_type_ids, this.props.blocId, getStateAccessor(this.props))
        newRow.id = rows.length + 1
        rows.push(newRow);

        let fieldValue = this.props.value;
        fieldValue.value_field_ids = rows

        this.props.fieldValueChange(fieldValue);
    }

    removeRow(rowToDelete) {
        const rows = this.props.value.value_field_ids.filter(r => !r.deleted && r.id !== 0);

        let indexOfRowToDelete = rowToDelete.index;
        let rowFound = rows[indexOfRowToDelete];

        if (!rowFound)
            return;

        rowFound.deleted = true;

        let fieldValue = this.props.value;
        fieldValue.value_field_ids = rows

        this.props.fieldValueChange(fieldValue);
    }

    renderButtons(row) {
        if (row.row.original.id === 0)
            return (
                <div>
                    <Button disabled={this.props.inputProperties.disabled} onClick={this.addRow.bind(this, row.row)}
                        className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin" color="primary">
                        <Icon className="small-icon">add</Icon>
                    </Button>
                </div>
            );

        return (
            <div className="solution-table-row-padding">
                <Button disabled={this.props.inputProperties.disabled} onClick={this.removeRow.bind(this, row.row)} className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin" color="primary">
                    <Icon className="small-icon">delete</Icon>
                </Button>
            </div>
        );
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        const rows = this.state.rows.filter((r) => !r.deleted)
        rows.push(getDefaultRow(this.props.model.field_type_ids, this.props.blocId, getStateAccessor(this.props)));

        return (
            <div className="control-margin-top">
                <TableWithoutPagination
                    minRows={2}
                    {...this.props.inputProperties}
                    data={rows}
                    columns={this.state.columns} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        loggedEmployee: state.loggedEmployee.loggedEmployee,
        fluidBottles: state.liquidBottles.myLiquidBottles,
        blocs: state.intervention.blocs,
        blocTypes: state.interventions.blocTypes,
        intervention: state.intervention.currentIntervention,
        sppFound: state.analyseRisques.sppFound,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InterventionArrayField);
